export function extractActiveReportName(pathname: string): string | null {
  // Match both /reports/grid/REPORTID and /reports/pbi/REPORTID patterns
  const gridMatch = pathname.match(/\/reports\/grid\/([^/?]+)/);
  if (gridMatch) return gridMatch[1];

  const pbiMatch = pathname.match(/\/reports\/pbi\/([^/?]+)/);
  if (pbiMatch) return pbiMatch[1];

  return null;
}
